import request from '@/utils/request'

export default {
  getBidding (params) {
    return request({
      url: 'activity/bid2buy/bidding',
      method: 'get',
      params
    })
  },
  postBidding (data) {
    return request({
      url: `activity/bid2buy/bidding/${data.orderSerial}`,
      method: 'post',
      data
    })
  },
  postTask (data) {
    return request({
      url: 'activity/bid2buy/task',
      method: 'post',
      data
    })
  }
}
